export const WATCHLIST_API_NAMES = {
  WatchListsGet1: `WatchListsGet1`,
  WatchListGet3: `WatchListGet3`,
  WatchListAddStock1: `WatchListAddStock1`,
  WatchListCreate1: `WatchListCreate1`,
  WatchListDelete1: `WatchListDelete1`,
  WatchListItemDelete1: `WatchListItemDelete1`,
  WatchListItemSave1: `WatchListItemSave1`,
  WatchListRename1: `WatchListRename1`,
  ThematicWatchlistsGet1: `ThematicWatchlistsGet1`,
  ThematicWatchlistGet1: `ThematicWatchlistGet1`,
  CloudThematicWatchlistsGet1: `/sb/watchlist/system/v1/thematic/get-all`,
  CloudThematicWatchlistGet1: `/sb/watchlist/system/v1/thematic/get-by-id`
};
